import axios from 'axios';
import React, { useEffect, useState, useContext } from 'react';
import { baseUrl } from '../utils.jsx/baseUrl';
import { useNavigate } from 'react-router';

function TestLoadboard() {
const [data , setData] = useState([]);
    useEffect(() => {
        
        (async () => {
            try {
                let res = await axios.get(`${baseUrl.url}/loads/get`, {
                    // headers: {
                    //   // Authorization: `Bearer ${token}`
                    // }
                  });
        
                  console.log(res.data, "response");
                  setData(res.data);
            } catch (error) {
                
              if (error.response && error.response.status === 404) {
                setData({});
              }
            }
          }
        
         )();
      }, []);

const thead = ["Tracking No." , "origin" , "destination" , "distance" , "equipment" , "Load count" ,"pickup-date"]

const definitions = [
  { description: "Auto Carrier", xml: { ac: "" } },
  { description: "Double Drop", xml: { dd: "" } },
  { description: "Dump Trailer", xml: { dt: "" } },
  { description: "Flatbed", xml: { f: "" } },
  { description: "Flatbed Hazardous", xml: { f: { hazmat: "true" } } },
  { description: "Flatbed or Step Deck", xml: { f : "" , sd: ""  } },
  { description: "Flatbed or Van", xml: { v: "" ,  f : "" } },
  { description: "Flatbed B-Train", xml: { f: { "b-train": "true" } } },
  { description: "Flatbed w/Pallet Exchange", xml: { f: { "palletexchange": "true" } } },
  { description: "Flatbed w/Sides", xml: { f: { "sides": "true" } } },
  { description: "Flatbed w/Tarps", xml: { f: { "tarps": "true" } } },
  { description: "Flatbed w/Team", xml: { f: { "team": "true" } } },
  { description: "Flatbed/Van/Reefer", xml: { v: "" ,  f : "" ,  r : "" } },
  { description: "Hopper Bottom", xml: { hb: "" } },
  { description: "Hotshot", xml: { f: { hotshot: "true" } } },
  { description: "Lowboy", xml: { lb: "" } },
  { description: "Maxi", xml: { f: { maxi: "true" } } },
  { description: "Power Only", xml: { po: "" } },
  { description: "Reefer", xml: { r: "" } },
  { description: "Reefer Hazardous" , xml: { r : { hazmat: "true" } } },
  { description: "Reefer or Van", xml: { v: "" ,  r : "" }},
  { description: "Reefer w/Pallet Exchange", xml: { r : { "palletexchange": "true" } } },
  { description: "Reefer/Flatbed/Van", xml: { v: "" ,  f : ""  , r : "" } },
  { description: "Removable Gooseneck", xml: { sd: { "removablegooseneck": "true" } } },
  { description: "Step Deck", xml: { sd : "" } },
  { description: "Tanker", xml: { t : "" } },
  { description: "Van", xml: { v : "" } },
  { description: "Van Hazardous" , xml: { v : { hazmat: "true" } } },
  { description: "Van Air-Ride" , xml: { v : { airride: "true" } } },
  { description: "Van or Flatbed", xml: { v: "" , f : "" } },
  { description: "Van or Reefer", xml: { v: "" ,  r : "" }},
  { description: "Van Vented" , xml: { v : { vented: "true" } } },
  { description: "Van w/Curtains" , xml: { v : { curtains: "true" } } },
  { description: "Van w/Pallet Exchange", xml: { v : { "palletexchange": "true" } } },
  { description: "Van w/Team" , xml: { v : { team: "true" } } },
  { description: "Van Walking Floor" , xml: { v : { walkingfloor : "true" } } },
];

const normalizeEquipmentXml = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeEquipmentXml);
  }

  if (value && typeof value === 'object') {
    const normalized = {};
    Object.keys(value).sort().forEach((key) => {
      if (key === '@') {
        Object.assign(normalized, normalizeEquipmentXml(value[key]));
      } else {
        normalized[key] = normalizeEquipmentXml(value[key]);
      }
    });
    return normalized;
  }

  if (value === true || value === 'true') {
    return true;
  }

  return value;
};

function findDefinition(query) {
  const normalizedQuery = JSON.stringify(normalizeEquipmentXml(query));
  const foundItem = definitions.find(item => JSON.stringify(normalizeEquipmentXml(item.xml)) === normalizedQuery);
  return foundItem ? foundItem.description : null;
}




const navigate = useNavigate();

const handleNavigate = (id) =>{
  navigate(`/loadboard-test/${id}`)
}

  return (
      <>
      <h1>Load board data</h1>

      <div>
        <table style = {{
          fontFamily: "arial",
          borderCollapse: "collapse",
          width: "100%"
          }}>
    <thead>
        <tr>
            {thead.map((item) =>{
               return  <th style = {{
                border: "1px solid #ffffff",
                textAlign: "left",
                padding: "8px",
              }}>{item}</th>
            })}
            </tr>
        </thead>

      <tbody>
            {data.map((load, dataIndex) => {
              // dataItem.Loads.map((load, loadIndex) =>
                // {
              console.log(load , "load")
                  // console.log(load.origin["date-start"].day ,"-" ,load.origin["date-start"].month , "-" , load.origin["date-start"].year, "load data ")
                     return (
                <tr key={`${dataIndex}`} onClick = {()  =>{ handleNavigate(load._id)}}>
                  <td style={{
                    border: "1px solid #ffffff",
                    textAlign: "left",
                    padding: "8px"
                  }}>{load["tracking-number"]}</td>
                  <td style={{
                    border: "1px solid #ffffff",
                    textAlign: "left",
                    padding: "8px"
                  }}>{load?.origin?.city}</td>
                  <td style={{
                    border: "1px solid #ffffff",
                    textAlign: "left",
                    padding: "8px"
                  }}>{load.destination.city}</td>
                  <td style={{
                    border: "1px solid #ffffff",
                    textAlign: "left",
                    padding: "8px"
                  }}>{load.distance}</td>
                   <td style={{border: "1px solid #ffffff",
                      textAlign: "left",
                      padding: "8px"
                   }}>
                    {/* {getEquipmentNames(load?.equipment)} */}
                    {findDefinition(load?.equipment)}
                    </td>
                  <td style={{
                    border: "1px solid #ffffff",
                    textAlign: "left",
                    padding: "8px"
                  }}>{load["load-count"]}</td>
                   <td style = {{
                    border : "1px solid #ffffff",
                    textAlign : "left",
                    padding : "8px"
                   }}>{`${load.origin["date-start"].day}-${load.origin["date-start"].month}-${load.origin["date-start"].year}`}</td>
                {/* {dataItem.PostingAccount.map((account, accountIndex) => (
                   <td style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px"
                  }}>{account.UserID}</td>
                  ))}  */}
                
              </tr>
              )
})
}           
            
          </tbody>
        </table>
      </div>
      </>
  );
}

export default TestLoadboard;
